import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

interface ContactUsRequest {
  message: string;
}

interface ContactUsResponse {
  message: string;
}

export const contactUsApi = createApi({
  reducerPath: "contactUsApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    sendContactUsMessage: build.mutation<ContactUsResponse, ContactUsRequest>({
      query: (body) => ({
        url: "/auth/contactus",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendContactUsMessageMutation } = contactUsApi;
